module.exports = __webpack_public_path__ + "static/img/active1.f72b044d.png";